import axios from "axios";

const postVenta = async (setShowWaitingDialog, setWaitingSeconds, setCountdown, isRetry = false) => {
  const formattedNic = localStorage.getItem("formattedNic");
  const token = localStorage.getItem("token");
  let facturaJson = localStorage.getItem("facturaJson");
  const cuponClover = localStorage.getItem("CuponClover");

  // Si es un reintento y hubo error de conexión, modificar el facturaJson
  if (isRetry) {
    const wasConnectionError = localStorage.getItem("lastErrorWasConnection") === "true";
    if (wasConnectionError) {
      const parsed = JSON.parse(facturaJson);
      parsed.cabecera = parsed.cabecera || {};
      parsed.cabecera.errorConexion = true;
      facturaJson = JSON.stringify(parsed);
    }
  }

  const userData = {
    nic: formattedNic,
    token: token,
    venta: facturaJson,
    // venta: JSON.stringify(testJson),
    cuponClover,
    serialNumberKeyClover: localStorage.getItem("serialNumberKeyClover"),
  };

  try {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/venta`, userData, {
      timeout: 300000,
      validateStatus: status => status < 500,
    });

    // Manejar código 425
    if (response.status === 425) {
      throw { code: "PROCESSING", message: "Factura en procesamiento" };
    }

    // Tratar código 429 exactamente igual que 200
    if (response.status === 200) {
      console.log(`✅ Respuesta exitosa (${response.status}):`, response.data);
      localStorage.setItem("CAE", response.data.CAE);
      localStorage.setItem("prefijo", response.data.Prefijo);
      localStorage.setItem("numero", response.data.Numero);

      // Limpiar flag de error de conexión después de éxito
      localStorage.removeItem("lastErrorWasConnection");

      return response;
    } else if (response.status === 429) {
      console.log(`✅ Respuesta exitosa (${response.status}):`, response.data);

      // Caso especial: si hay que reintentar automáticamente
      if (response.data.error === "TRANSACTION_FAILED_RECENTLY" && response.data.reintentar === true) {
        const esperarSegundos = response.data.esperarSegundos || 2;
        console.log(`⏳ Esperando ${esperarSegundos} segundos antes de reintentar...`);

        // Mostrar el diálogo y configurar el countdown
        if (setShowWaitingDialog && setWaitingSeconds && setCountdown) {
          setShowWaitingDialog(true);
          setWaitingSeconds(esperarSegundos);
          setCountdown(esperarSegundos);

          // Countdown timer
          for (let i = esperarSegundos; i > 0; i--) {
            await new Promise(resolve => setTimeout(resolve, 1000));
            setCountdown(i - 1);
          }

          // Ocultar el diálogo
          setShowWaitingDialog(false);
        } else {
          // Fallback si no se pasan las funciones
          await new Promise(resolve => setTimeout(resolve, esperarSegundos * 1000));
        }

        // Reintentar la llamada recursivamente
        console.log("🔄 Reintentando llamada automáticamente...");
        return await postVenta(setShowWaitingDialog, setWaitingSeconds, setCountdown, isRetry);
      }

      // Casos normales: transacción ya procesada exitosamente
      localStorage.setItem("CAE", response.data.CAE);
      localStorage.setItem("prefijo", response.data.Prefijo);
      localStorage.setItem("numero", response.data.Numero);

      // Limpiar flag de error de conexión después de éxito
      localStorage.removeItem("lastErrorWasConnection");

      // Manejar ambos formatos: originalResponse y errorOriginal
      const dataToReturn = response.data.originalResponse || response.data.errorOriginal;

      return {
        data: dataToReturn,
      };
    }

    // Para otros códigos de éxito (201, 202, etc.)
    console.log(response.data);
    localStorage.setItem("CAE", response.data.CAE);
    localStorage.setItem("prefijo", response.data.Prefijo);
    localStorage.setItem("numero", response.data.Numero);

    // Limpiar flag de error de conexión después de éxito
    localStorage.removeItem("lastErrorWasConnection");

    return response;
  } catch (error) {
    if (error.code === "PROCESSING") {
      throw error;
    }
    console.log(error.response?.data?.message || error.message);
    localStorage.setItem("errorMensaje", error.response?.data?.exceptionMessage || error.message);
    localStorage.setItem("reintentos", 1);
    throw error;
  }
};

const venta = {
  postVenta,
};

export default venta;
